// @ts-nocheck
import { orderPoStyles, OrderPoStyles } from "@insite/content-library/Widgets/OrderDetails/OrderPo";
import { infoProps } from "@store/Themes/common/props/info";

Object.assign<OrderPoStyles>(orderPoStyles, {
    wrapper: {},
    titleText: infoProps.label,
    orderPo: infoProps.value,
});
